export default __webpack_public_path__ + "static/media/Dylan_Zeigler_Resume.b707dafd.pdf";